import React, {Fragment, useEffect} from 'react';
import {Alert, Button, Card, Col, Form, Input, Modal, Row} from 'antd';
import   ZoomableTextArea from '../../../../../components/zoomable-textarea';
import {translate} from 'react-i18next';
import EnhancedModal from "../../../../../components/enhanced-modal";
import PerfInput from "../../../../../components/perf-input";
import {
    resetSaveStatusMappingSet,
    saveMappingSetOnServer,
    updateFieldsMappingSet,
} from "../actions";
import {compose} from "redux";
import {connect} from "react-redux";
import {GUTTER_MD, GUTTER_SM} from "../../../../../styles/constants";
import {prepareMappingSetForSaving} from "../utils";

const mapStateToProps = ({
                             scenes: {mappingHandler: {mappingSet: {wizard, index, tree}}}
                         }) => ({
    name: wizard.name,
    tempName: wizard.tempName,
    tempDescription: wizard.tempDescription,
    dataflow: index.dataflow,
    selectedDataset: wizard.selectedDataset,
    selectedMappingSet: wizard.selectedMappingSet,
    description: wizard.description,
    stash: wizard.stash,
    saveValidationSuccessful: wizard.saveValidationSuccessful,
    mappingSets: tree.mappingSets,
});

const mapPropsToFields = ({tempName, tempDescription}) => {
    return {
        tempName: Form.createFormField({value: tempName || ""}),
        tempDescription: Form.createFormField({value: tempDescription || ""}),
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateFields: (fields) => dispatch(updateFieldsMappingSet(fields)),
        saveMappingSet: (mappingSetData, isSilent) => dispatch(saveMappingSetOnServer(mappingSetData, true, isSilent)),
        resetSaveStatus: () => dispatch(resetSaveStatusMappingSet(true)),
    }
}

const onFieldsChange = ({updateFields}, fields) => updateFields(fields);


const SaveMappingWithNameAlert = ({
                             t,
                             isVisible,
                             onHide,
                             width,
                             tempName,
                             tempDescription,
                             name,
                             form,
                             dataflow,
                             selectedDataset,
                             selectedMappingSet,
                             description,
                             stash,
                             saveMappingSet,
                             saveValidationSuccessful,
                             resetSaveStatus,
                             callback,
                             silent,
                             mappingSets,
                         }) => {
    useEffect(() => {
        if (silent && !saveValidationSuccessful && !!isVisible) {
            saveMappingSet(prepareMappingSetForSaving(tempName || name, description, selectedMappingSet, selectedDataset, dataflow, (stash || []).filter(row => !row.entityId)), true);
        }
    }, [silent, saveValidationSuccessful, isVisible]);

    useEffect(() => {
        if (saveValidationSuccessful && !!isVisible) {
            if (!!callback) callback();
            onHide();
            resetSaveStatus();
        }
    }, [saveValidationSuccessful, dataflow, selectedMappingSet, isVisible, callback]);

    if (silent) {
        return <Fragment />;
    }

    return (
        <EnhancedModal
            visible={isVisible}
            onCancel={onHide}
            footer={<Row type="flex" justify="end" align="middle" gutter={GUTTER_SM}>
                <Col>
                    <Button onClick={onHide}>{t('commons.buttons.close.title')}</Button>
                </Col>
                {!silent && (<Col>
                    <Button
                        type="primary" onClick={() => {
                        if (!tempName && !name) {
                            Modal.warning({
                                title: t('commons.alerts.invalidForm.title'),
                                content: t('commons.alerts.invalidForm.content')
                            });
                            return;
                        }
                        if ((mappingSets || []).map(item => item.name).includes(tempName || name)) {
                            Modal.warning({
                                title: t('commons.alerts.invalidForm.title'),
                                content: t('scenes.mappingHandler.MappingSet.wizard.steps.second.mappingNeedsToBeSavedAlert.nameAlreadyExists')
                            });
                            return;
                        }
                        saveMappingSet(prepareMappingSetForSaving(tempName || name, tempDescription || description, selectedMappingSet, selectedDataset, dataflow, (stash || []).filter(row => !row.entityId)), false);
                    }}>{t('commons.buttons.confirm.title')}</Button>
                </Col>)}
            </Row>}
            width={width}
            title={!silent? t("scenes.mappingHandler.MappingSet.wizard.steps.second.mappingNeedsToBeSavedAlert.title") : ""}
        >
            {!silent && (<Fragment>
                <Alert
                    style={{marginBottom: GUTTER_MD}}
                    message={t("scenes.mappingHandler.MappingSet.wizard.steps.second.mappingNeedsToBeSavedAlert.content")}
                    type="warning"
                    showIcon
                />
                {!name && <Card>
                    <div>
                        {t("scenes.mappingHandler.MappingSet.wizard.steps.second.mappingNeedsToBeSavedAlert.needsName")}
                    </div>
                    <Form>
                        <Form.Item
                            label={t('scenes.mappingHandler.MappingSet.wizard.steps.third.name')}
                            className="ant-form-item-required"
                            required
                            validateStatus={(tempName || name) && (mappingSets || []).map(item => item.name).includes(tempName || name) ? "warning" : null}
                            help={(tempName || name) && (mappingSets || []).map(item => item.name).includes(tempName || name) ? t("scenes.mappingHandler.MappingSet.wizard.steps.second.mappingNeedsToBeSavedAlert.nameAlreadyExists") : null}
                        >
                            {form.getFieldDecorator('tempName')(
                                <PerfInput
                                    Component={Input}
                                    title={tempName}
                                />
                            )}
                        </Form.Item>
                        <Form.Item
                            label={t('scenes.mappingHandler.MappingSet.wizard.steps.third.description')}>
                            {form.getFieldDecorator('tempDescription')(
                                <ZoomableTextArea 
                                    title={tempDescription}
                                />
                            )}
                        </Form.Item>
                    </Form>
                </Card>}
            </Fragment>)}
        </EnhancedModal>
    )
};

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps),
    Form.create({mapPropsToFields, onFieldsChange}),
)(SaveMappingWithNameAlert);
